import React, { useContext, useState } from 'react';
import { sendEmailVerification, getAuth } from 'firebase/auth';
import { toast } from 'react-toastify';
import { firebaseAuth } from '../../providers/AuthProvider';

const VerifyEmail = () => {
  const { user, handleSignout, refreshClaims } = useContext(firebaseAuth);
  const [sending, setSending] = useState(false);
  const auth = getAuth();

  const resend = async () => {
    if (!auth.currentUser) return;
    setSending(true);
    try {
      await sendEmailVerification(auth.currentUser);
      toast.success('Verification email sent. Check your inbox.');
    } catch (err) {
      toast.error(err.message || 'Could not send verification email.');
    } finally {
      setSending(false);
    }
  };

  const recheck = async () => {
    if (!auth.currentUser) return;
    await auth.currentUser.reload();
    await refreshClaims();
    if (!auth.currentUser.emailVerified) {
      toast.info(
        'Email is not yet verified. Click the link in the email and try again.',
      );
    }
  };

  return (
    <div>
      <h1 className="text-xl font-semibold tracking-tight text-zinc-900 dark:text-white">
        Verify your email
      </h1>
      <p className="mt-2 text-sm text-zinc-600 dark:text-zinc-400">
        We sent a verification email to <span className="text-zinc-900 dark:text-white">{user?.email}</span>.
        Click the link in that email to verify your address.
      </p>
      <p className="mt-2 text-sm text-zinc-500">
        Didn't get it? Check spam, or resend below.
      </p>
      <div className="mt-6 grid gap-3 sm:grid-cols-2">
        <button
          type="button"
          onClick={resend}
          disabled={sending}
          className="inline-flex items-center justify-center rounded-md bg-zinc-900 px-3 py-2 text-sm font-semibold text-zinc-50 shadow-sm hover:bg-zinc-800 disabled:cursor-not-allowed disabled:opacity-60 dark:bg-white dark:text-zinc-900 dark:hover:bg-zinc-100"
        >
          {sending ? 'Sending…' : 'Resend email'}
        </button>
        <button
          type="button"
          onClick={recheck}
          className="inline-flex items-center justify-center rounded-md bg-zinc-100 px-3 py-2 text-sm font-semibold text-zinc-900 shadow-sm ring-1 ring-inset ring-zinc-300 hover:bg-zinc-200 dark:bg-zinc-800 dark:text-white dark:ring-white/10 dark:hover:bg-zinc-700"
        >
          I've verified — continue
        </button>
      </div>
      <div className="mt-6 text-sm">
        <button
          type="button"
          onClick={handleSignout}
          className="text-zinc-600 hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-white"
        >
          Sign out
        </button>
      </div>
    </div>
  );
};

export default VerifyEmail;
